import { render } from "./main.vue?vue&type=template&id=3b6fb3ed&scoped=true&lang=pug"
import script from "./main.vue?vue&type=script&lang=js"
export * from "./main.vue?vue&type=script&lang=js"

import "./main.vue?vue&type=style&index=0&id=3b6fb3ed&lang=scss"
import "./main.vue?vue&type=style&index=1&id=3b6fb3ed&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b6fb3ed"]])

export default __exports__